export default {
    name: 'eventos',
    component: () => import(/* webpackChunkName: "General" */ '@/layouts/General.vue'),
    children: [
        {
            path: '',
            name: 'home-eventos',
            component: () => import('@/modules/eventos/view/Home.vue'),
        },
        {
            path: ':id',
            name: 'edit-eventos',
            component: () => import('@/modules/eventos/view/Add.vue'),
            props: (route) => {
                return {
                    id: route.params.id
                }
            }
        }
    ]

}